/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OpenAPIv3SecuritySchemeSummary = {
  /**
   * The environment variables that supply credentials for the scheme.
   */
  envVariables: Array<string>;
  /**
   * The name of the scheme under components.securitySchemes.
   */
  key: string;
  /**
   * A short description of the scheme.
   */
  summary: string;
  /**
   * The OpenAPI security scheme type.
   */
  type: string;
};

/** @internal */
export const OpenAPIv3SecuritySchemeSummary$inboundSchema: z.ZodMiniType<
  OpenAPIv3SecuritySchemeSummary,
  unknown
> = z.pipe(
  z.object({
    env_variables: z.array(z.string()),
    key: z.string(),
    summary: z.string(),
    type: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "env_variables": "envVariables",
    });
  }),
);

export function openAPIv3SecuritySchemeSummaryFromJSON(
  jsonString: string,
): SafeParseResult<OpenAPIv3SecuritySchemeSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OpenAPIv3SecuritySchemeSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OpenAPIv3SecuritySchemeSummary' from JSON`,
  );
}
